<template>
  <main>
      <profileinformation></profileinformation>
  </main>
</template>
<script>
import profileinformation from './ProfileInformation'
export default {
  name: 'profilesetup',
  components: {
    profileinformation
  }
}
</script>


// WEBPACK FOOTER //
// ProfileSetup.vue?33336cc2